function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#gradi{fill:url(#MyGradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "MyGradient",
  x1: 176.22,
  y1: -64.14,
  x2: 330.55,
  y2: 359.88,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#107ff9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#2fb7ed"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "gradi",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "",
  d: "M0,0V117.34H502.87V0ZM109,83.8H58.67V33.51H109ZM0,285H234.63V430.15a42.74,42.74,0,0,0-22.42,22.44H85.2v33.52h127a42.64,42.64,0,0,0,78.42,0H417.68V452.59h-127a42.74,42.74,0,0,0-22.47-22.45V285H502.87V167.62H0Zm58.67-83.83H109v50.29H58.67Z"
})));

var SvgFeature01 = function SvgFeature01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 502.87 512.01",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeature01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feature01.f794c16d.svg";
export { ForwardRef as ReactComponent };